<script setup lang="ts">
import {computed} from 'vue';
import {useOrderViewContext, useProcesses} from '@hantera/portal-app';
import {ActivityLogEntry} from "@hantera/design-system";

const props = defineProps<{
  entry: ActivityLogEntry
}>()

const orderViewContext = useOrderViewContext();

const procs = useProcesses()

const isActive = computed(() => {
  return orderViewContext.timetravelState.isActive &&
    orderViewContext.timetravelState.checkpointId === props.entry.dynamic.checkpoint.checkpointId;
});

const isLatest = computed(() => {
  const checkpoints = orderViewContext.state.checkpoints;
  if (!checkpoints || checkpoints.length === 0) return false;
  const latestCheckpoint = checkpoints[checkpoints.length - 1];
  return latestCheckpoint.checkpointId === props.entry.dynamic.checkpoint.checkpointId;
});

async function handlePreview() {
  try {
    await orderViewContext.enterTimetravel(props.entry.dynamic.checkpoint.checkpointId, props.entry.dynamic.checkpoint.timestamp);
    await orderViewContext.refresh()
  } catch (e) {
    procs.error({
      title: 'Failed to preview checkpoint',
      message: e as string
    })
    await orderViewContext.exitTimetravel()
  }
}
</script>

<template>
  <div class="checkpoint-entry" :class="{ 'checkpoint-entry--active': isActive, 'checkpoint-entry--latest': isLatest }">
    <div class="checkpoint-divider"></div>
    <span v-if="isLatest" class="checkpoint-label">
      Current Checkpoint
    </span>
    <button
      v-else
      class="btn-silent"
      @click="handlePreview"
      :disabled="isActive"
    >
      {{ isActive ? 'Previewing' : 'Checkpoint' }}
    </button>
    <div class="checkpoint-divider"></div>
  </div>
</template>

<style scoped>
.checkpoint-entry {
  display: grid;
  grid-template-columns: auto max-content auto;
  gap: 1rem;
  align-items: center;
}

.checkpoint-divider {
  height: 0;
  width: 100%;
  border-top: 2px dotted hsl(var(--color-60));
}

.checkpoint-entry--active {
  background-color: var(--color-warning-100);
  border: 1px solid var(--color-warning-25);
  padding: 0 5px;
  border-radius: 4px;
}

.checkpoint-entry--active .checkpoint-divider {
  border-color: var(--color-warning-25);
}

.checkpoint-entry--active button {
  font-weight: 600;
  color: var(--color-warning-0);
}

.checkpoint-entry--latest .checkpoint-label {
  font-weight: 600;
  color: hsl(var(--color-30));
}
</style>
